import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Municipality } from '../components/shared/utils';
import { MunicipalityService } from '../services/municipality.service';

/**
 * This pipe convert a cap of a municipality in the readable:
 * municipality.name (municipality.province) string. It is an asynchrounous pipe
 * because it uses the municipality service 
 */
@Pipe({
  name: 'municipalityCap',
  standalone: true
})
export class MunicipalityCapPipe implements PipeTransform {

  constructor(private municipalityService: MunicipalityService) {}

  transform(cap: string | null | undefined): Observable<string> {
    if (!cap) {
      return of('');
    }
    
    return this.municipalityService.getMunicipalityByCap(cap).pipe(
      map((municipality: Municipality | undefined) => {
        if (municipality) {
          return `${municipality.name} (${municipality.province})`;
        }
        return cap; // Fallback to CAP if municipality not found
      }),
      catchError(() => of(cap)) // Fallback to CAP on error
    );
  }
}